import axios from "axios";
import logger from "./logService";
import { showNotification } from "@mantine/notifications";

axios.defaults.baseURL = "https://track.bugilabs.com/api";
// axios.defaults.baseURL = "http://localhost:3903/api";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  const networkError =
    error.response &&
    (error.response.status === 500 || error.response.status === null);

  if (networkError) {
    logger.log(error);
    showNotification({
      title: "Network error",
      message: "Check internet connection",
      color: "red",
    });
    // message.error("Network error!");
  } else if (!expectedError) {
    logger.log(error);
    showNotification({
      title: "Something went wrong",
      message: "Please try again",
      color: "red",
    });
    // message.error("An unexpected error occurred.");
  }

  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  setJwt,
};
